import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import IForm from '../../../components/i-form/i-form.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import './signin.component.scss';
import { isNotEmpty, isNotNull } from '../../common/util.services';
import { useContext } from 'react';
import { AppContext } from '../../../app-context';
import { ACCESS_TOKEN } from '../../common/constants';
import { signin } from '../user.services';

const SigninComponent = () => {
  const appContext = useContext(AppContext);
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    appContext.setShowLoader(true);
    signin(data, appContext,
      (response: any) => {
        if (isNotNull(response.data) && isNotEmpty(response.data.authToken)) {
          appContext.setUserData(response.data);
          localStorage.setItem(ACCESS_TOKEN, response.data.authToken);
          navigate('/task/general/list');
        }
        appContext.setSuccessMessage(response.message)
        appContext.setShowLoader(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message)
      }
    );
  }
  const getMainComponent = () => {
    return <Grid container spacing={2} >
    <Grid xs={12}>
      <ITextField type="number" name='userId' label='Phone' required={true}></ITextField>
    </Grid>
    <Grid xs={12}>
      <ITextField  type="password" name='password' label='Password' required={true}></ITextField>
    </Grid>
  </Grid>
  }

  return <div className="sign-in">
    <IForm title='Sign-in' submitForm={onSubmit} mainComponent={getMainComponent()} showCancelBtn={false}></IForm>
    </div>
}

export default SigninComponent;